module.exports = "../../../../platform/assets/pageMainIcon/cd-number-rate.svg";